'use client';

import { useRef, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import mixpanel from 'mixpanel-browser';
import { faqEntries, FaqEntry } from './faq-content';

const FaqItem = ({ item }: { item: FaqEntry }) => {
  const accordion = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <li className="border-b border-ink-900/15 last:border-0">
      <button
        className="relative flex gap-3 items-center w-full py-5 text-left"
        onClick={(e) => {
          e.preventDefault();
          const willOpen = !isOpen;
          if (willOpen) {
            mixpanel.track('kahoot_alt_faq_opened', {
              question: item.question,
            });
          }
          setIsOpen(willOpen);
        }}
        aria-expanded={isOpen}
      >
        <span
          className={`flex-1 font-display font-semibold text-lg md:text-xl ${
            isOpen ? 'text-brand-600' : 'text-ink-900'
          }`}
        >
          {item.question}
        </span>
        <ChevronDown
          className={`w-5 h-5 text-ink-400 transition-transform duration-200 ${
            isOpen ? 'rotate-180' : ''
          }`}
        />
      </button>

      <div
        ref={accordion}
        className="transition-all duration-300 ease-in-out overflow-hidden"
        style={
          isOpen
            ? { maxHeight: accordion?.current?.scrollHeight, opacity: 1 }
            : { maxHeight: 0, opacity: 0 }
        }
      >
        <div className="pb-5 text-ink-600 leading-relaxed">{item.answer}</div>
      </div>
    </li>
  );
};

export default function AltFAQ() {
  return (
    <section className="bg-paper-100 paper-grain" id="faq">
      <div className="py-20 lg:py-28 px-6 lg:px-8 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="flex flex-col text-left lg:basis-1/3">
            <p className="font-hand text-brand-600 text-2xl mb-3 -rotate-2 inline-block">
              before you switch
            </p>
            <h2 className="font-display font-black text-4xl md:text-5xl tracking-[-0.02em] text-ink-900 leading-[1.02]">
              Common
              <br />
              <span className="italic font-normal">questions.</span>
            </h2>
          </div>

          <ul className="lg:basis-2/3">
            {faqEntries.map((item) => (
              <FaqItem key={item.question} item={item} />
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
